import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

export const app = initializeApp({
  apiKey: "AIzaSyB28Z_mjb5wWUqdRzmUNKHH84CGnjPvS5U",
  authDomain: "roveride-website.firebaseapp.com",
  projectId: "roveride-website",
  storageBucket: "roveride-website.firebasestorage.app",
  messagingSenderId: "529094662015",
  appId: "1:529094662015:web:ea4d04a902f5e9fc56ec4a",
  measurementId: "G-6Y4NTE4PKP",
});
export const auth = getAuth(app);
